import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    quoteNumber: string;
    osnQuoteDetailsPageUrl?: string;
    osnEditQuotePageUrl?: string;
    status?: string;
}
type Props = OwnProps & HasHistory;

export interface OrderDetailsButtonSetStyles {
    buttonsWrapper?: InjectableCss;
    overflowMenu?: OverflowMenuPresentationProps;
    clickableBtn?: ClickablePresentationProps;
}

export const orderDetailsButtonSetStyles: OrderDetailsButtonSetStyles = {
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            clear: both;
        `,
    },
    overflowMenu: {
        buttonProps: {
            css: css`
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                background-color: transparent;
                border-color: transparent;
                &:hover {
                    background-color: transparent;
                    border-color: transparent;
                }
            `,
        },
    },
};

const styles = orderDetailsButtonSetStyles;

const OrderDetailsKebabMenu: React.FC<Props> = ({
    history,
    quoteNumber,
    osnQuoteDetailsPageUrl,
    osnEditQuotePageUrl,
    status,
}) => {
    return (
        <StyledWrapper {...styles.buttonsWrapper} className="kabab-menu">
            <OverflowMenu hasChildPortal position="end" {...styles.overflowMenu}>
                <Clickable
                    {...styles.clickableBtn}
                    onClick={() => history.push(`${osnQuoteDetailsPageUrl}?quote=${quoteNumber}`)}
                >
                    {translate("View")}
                </Clickable>
                {status && status.toLowerCase() === "draft" && (
                    <Clickable
                        {...styles.clickableBtn}
                        onClick={() => history.push(`${osnEditQuotePageUrl}?quote=${quoteNumber}`)}
                    >
                        {translate("Edit")}
                    </Clickable>
                )}
            </OverflowMenu>
        </StyledWrapper>
    );
};

export default withHistory(OrderDetailsKebabMenu);
